.labelWithEllipsis {
  overflow: hidden;
}

/* .labelWithEllipsis > p {
  width: 100%;
} */
